//
// Module for the split account drop page
//
rs.module("participant/member/splitaccount/splitaccountdrop",

    ["common/select-helper", "common/visibility", "controls/components/event-banner"],

    function (selectHelper, visibility, eventBanner) {

        function initialize(jsSelectors, percentageCodeValue, backendUrls) {
            var form = $.js(jsSelectors.form);
            var fromDate = form.js(jsSelectors.fromDate);
            var fromDateHidden = form.js(jsSelectors.fromDateHidden);
            var method = form.js(jsSelectors.method);
            var methodHidden = form.js(jsSelectors.methodHidden);
            var percent = form.js(jsSelectors.percent);
            var percentHidden = form.js(jsSelectors.percentHidden);
            var droAccountPartyKey = form.js(jsSelectors.droAccountPartyKey);
            var dropAccountBalance = form.js(jsSelectors.dropAccountBalance);
            var dropAccountBalanceHidden = form.js(jsSelectors.dropAccountBalanceHidden);
            var transferToDroAmount = form.js(jsSelectors.transferToDroAmount);
            var fromDropAccountKeyHidden = form.js(jsSelectors.fromDropAccountKeyHidden);
            var splitAccountDetail = form.js(jsSelectors.splitAccountDetail);
            var hasSubmittedHidden = form.js(jsSelectors.hasSubmittedHidden);

            var submitButton = form.js(jsSelectors.submitButton);
            var backButton = form.js(jsSelectors.backButton);
            var saveButton = form.js(jsSelectors.saveButton);
            var cancelButton = form.js(jsSelectors.cancelButton);

            toggleInputs(hasSubmittedHidden.val().toLowerCase() == "true");
 
            method.change(function () {
                percent.prop("disabled", method.val() != percentageCodeValue);
                if (method.val() != percentageCodeValue) {
                    percent.val(null);
                }
            });

            // When submit is clicked calculate the DROP information and return the results
            submitButton.click(function () {
                // Validate form before performing calc
                var validator = form.closest("form").validate();
                var isValid = validator.form();

                if (isValid) {
                    $.get(backendUrls.dropCalculate, { droAccountPartyKey: droAccountPartyKey.val(), dropPostedDate: fromDate.val(), splitAccountMethod: method.val(), percent: (percent.val() / 100.00000).toFixed(5) }
                        ).done(function (data) {
                            fromDropAccountKeyHidden.val(data.fromDropAccountKey);
                            dropAccountBalance.val(data.dropAccountBalance);
                            dropAccountBalanceHidden.val(data.dropAccountBalance);
                            transferToDroAmount.val(data.transferToDroAmount);

                            // Set hidden fields from inputs being disabled
                            fromDateHidden.val(fromDate.val());
                            methodHidden.val(method.val());
                            percentHidden.val(percent.val());

                            toggleInputs(true);
                        }).fail(function () {
                            toggleInputs(false);
                        });
                }
            });

            // Toggle fields based on if the user has submitted/calculated already
            function toggleInputs(submitted) {
                if (submitted) {
                    splitAccountDetail.show();
                    submitButton.hide();
                    backButton.hide();
                    cancelButton.show();
                    saveButton.show();
                }
                else {
                    splitAccountDetail.hide();
                    submitButton.show();
                    backButton.show();
                    cancelButton.hide();
                    saveButton.hide();
                }

                // Populate hidden fields from inputs
                fromDateHidden.val(fromDate.val());
                methodHidden.val(method.val());
                percentHidden.val(percent.val());

                fromDate.prop("disabled", submitted);
                selectHelper.getHelper(method).setDisabled(submitted);

                if (submitted) {
                    percent.prop("disabled", submitted);
                }

                fromDateHidden.prop("disabled", !submitted);
                methodHidden.prop("disabled", !submitted);
                percentHidden.prop("disabled", !submitted);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);